export default __webpack_public_path__ + "static/media/olacacheada.1befa6ee.jpg";